import type { WhoopAllData } from "../devices-types";
import { CyclesCard } from "./CyclesCard";
import { ProfileCard } from "./ProfileCard";
import { RecoveryCard } from "./RecoveryCard";
import { SleepCard } from "./SleepCard";
import { WorkoutsCard } from "./WorkoutsCard";

interface WhoopDataDashboardProps {
  data: WhoopAllData;
  isLoading: boolean;
}

export function WhoopDataDashboard({
  data,
  isLoading,
}: WhoopDataDashboardProps): React.ReactElement {
  return (
    <div data-testid="whoop-data-dashboard" className="space-y-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <RecoveryCard recovery={data.recovery} isLoading={isLoading} />
        <SleepCard sleep={data.sleep} isLoading={isLoading} />
        <ProfileCard profile={data.profile} body={data.body} isLoading={isLoading} />
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <CyclesCard cycles={data.cycles} isLoading={isLoading} />
      </div>
      <WorkoutsCard workouts={data.workouts} isLoading={isLoading} />
    </div>
  );
}
